import { render, staticRenderFns } from "./_adminAside.vue?vue&type=template&id=74f979eb&scoped=true"
import script from "./_adminAside.vue?vue&type=script&lang=js"
export * from "./_adminAside.vue?vue&type=script&lang=js"
import style0 from "./_adminAside.vue?vue&type=style&index=0&id=74f979eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f979eb",
  null
  
)

export default component.exports